/**
 * Consulta matriz efectiva de permisos (alineada a functions/utils/resolvePermisos.matrixAllows).
 * Fail-closed. Soporta claves planas con punto (ej. cuenta_corriente.ver) y anidadas.
 *
 * @param {object|null|undefined} permissions
 * @param {string} module
 * @param {string} action
 * @returns {boolean}
 */
export function matrixAllows(permissions, module, action) {
  if (!permissions || typeof permissions !== 'object') return false;
  const mod = String(module || '').trim();
  const act = String(action || '').trim();
  if (!mod || !act) return false;

  if (act.includes('.')) {
    if (permissions[mod]?.[act] === true) return true;
    const [sub, subAct] = act.split('.');
    if (subAct != null && permissions[mod]?.[sub]?.[subAct] === true) return true;
    return false;
  }

  if (mod === 'caja') {
    const c = permissions.caja || {};
    if (act === 'cerrar') return c.cerrar === true || c.crear === true;
    if (act === 'ver_cierres') {
      return c.ver_cierres === true || c.editar === true || c.corregir_cierre === true;
    }
    if (act === 'corregir_cierre') return c.corregir_cierre === true || c.editar === true;
  }

  if (mod === 'compras' && (act === 'recibir' || act === 'pagar')) {
    return permissions.compras?.[act] === true;
  }
  if (mod === 'compras' && act === 'anular') {
    if (permissions.compras?.anular === true) return true;
    if (permissions.compras?.anular === false) return false;
    return permissions.compras?.eliminar === true || permissions.compras?.editar === true;
  }

  return permissions[mod]?.[act] === true;
}

/**
 * Parsea "modulo.accion" o "modulo.sub.accion" → [modulo, accionCompleta].
 * @param {string} permission
 * @returns {[string, string]|null}
 */
export function splitPermissionKey(permission) {
  const raw = String(permission || '').trim();
  if (!raw) return null;
  const parts = raw.split('.');
  if (parts.length < 2) return [parts[0], 'ver'];
  return [parts[0], parts.slice(1).join('.')];
}
